module.exports = __webpack_public_path__ + "static/media/face_example.379f7f6e.gif";